import React, {useEffect, useState} from 'react';
import {Button, Flex} from "antd";
import {useViewerStore} from '../../../../../store/store';
import {
    ACCESS_MULTIPLIERS,
    FACE_IDEAL_API,
    MODULE_GRAPH,
    SHADE_CALCULATIONS,
    siteCalculationState
} from "../../../../../services/siteCalculationState";
import completedIcon from "../../../../../assets/img/icons/completed-icon.png";
import errorIcon from "../../../../../assets/img/icons/error-icon.png";
import {useCalculationStates} from "../../../../../hooks/calculationStateHook";

const GenFilePopup = () => {

    const {sceneViewer, shadeCalculatingIdx, shadeCalculatingLength, refreshingShade} = useViewerStore(state => state);
    const [genFileGenerationStatus, setGenFileGenerationStatus] = useState('default');
    const {needsUpdate} = useCalculationStates([FACE_IDEAL_API, MODULE_GRAPH, SHADE_CALCULATIONS, ACCESS_MULTIPLIERS], {useCalculation: true});
    const [calculationReady, setCalculationReady] = useState(false);

    const confirmGenerateGenFile = async () => {
        setGenFileGenerationStatus('generating');
        const gen = await sceneViewer.exportJson();
        if(gen){
            setGenFileGenerationStatus('success');
        }
        else{
            setGenFileGenerationStatus('error');
        }
    }

    useEffect(()=>{
        siteCalculationState.needsUpdate(SHADE_CALCULATIONS);
        siteCalculationState.useCalculations(SHADE_CALCULATIONS);
    }, []);

    useEffect(()=>{
        const isReady = !(refreshingShade || Object.values(needsUpdate).includes(true));
        setCalculationReady(isReady);
        setGenFileGenerationStatus(isReady? 'default' : 'calculating');
    }, [needsUpdate, refreshingShade]);

    const cancel = () => {
        //Close Alert
        sceneViewer.viewerAlert({show: false});
    };

    return (
        <>
            {
                genFileGenerationStatus === 'success' ? (<Flex vertical justify={'center'} align={'center'}>                      
                    <p className="report-text">.GEN File Generated Successfully</p>
                    <img
                        src={completedIcon}
                        alt={"Completed Icon"}
                        width={50}
                        height={50}
                    />
                </Flex>) : genFileGenerationStatus === 'error' ? (<Flex vertical justify={'center'} align={'center'} gap={5}>
                    <p>.GEN File Generation Failed</p>
                    <img
                        src={errorIcon}
                        alt={"Error Icon"}
                        width={50}
                        height={50}
                    />
                    </Flex>) : genFileGenerationStatus === 'calculating' ? (<Flex justify={'center'} align={'center'} gap={10}>
                        <span className="loader-icon-spinner"></span>
                        <p>Re-Calculating shades for all roofs : {shadeCalculatingIdx} of {shadeCalculatingLength}</p>

                    </Flex>) : genFileGenerationStatus === 'generating' ? (<Flex justify={'center'} align={'center'} gap={10}>
                        <span className="loader-icon-spinner"></span>
                        <p>Generating oneDRAW .GEN File</p>

                    </Flex>) :

                    (<>
                        {calculationReady
                            ?
                            <p className="report-text">Click Confirm to Generate and Download oneDRAW .GEN File</p>
                            : <p className="report-text">Please wait, values are still being calculated...</p>}

                        <div className={"modal-bottom-action-button-container"}>
                            <Button
                                id={"confirmSiteReportBtn"}
                                type="primary"
                                size="large"
                                className="editor__control--finalize modal-confirm-button"
                                disabled={!calculationReady}
                                onClick={confirmGenerateGenFile}
                            >
                                Confirm
                            </Button>
                            <Button
                                type="primary"
                                size="large"
                                className="editor__control--finalize modal-cancel-button"
                                onClick={cancel}
                            >
                                Cancel
                            </Button>
                        </div>
                    </>)
            }
        </>
    )
}

export default GenFilePopup;